export default "__VITE_ASSET__DVDCVBlX__"